import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_2 = { class: "tooltip__icon" }
const _hoisted_3 = { class: "tooltip__content" }
const _hoisted_4 = { class: "tooltip__title" }

import {ref, watch} from "vue";


const __default__ = {
  name: 'vita-tooltip'
}

interface Props {
  title: string,
  text: string,
  open: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    text: {},
    open: { type: Boolean }
  },
  emits: ['closed'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const isOpen = ref<boolean>(props.open)
const emit = __emit

watch(props,(val: Props) => {
  isOpen.value = val.open
})

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!

  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_vita_icon, { name: "info" })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.title), 1),
          _createElementVNode("p", null, _toDisplayString(__props.text), 1)
        ]),
        _createElementVNode("div", {
          class: "tooltip__close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closed'))),
          "data-qa": "tooltip-icon-close"
        }, [
          _createVNode(_component_vita_icon, { name: "cross" })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})